import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-982607d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center p-4 bg-raven" }
const _hoisted_2 = { class: "flex flex-col gap-3" }
const _hoisted_3 = { class: "caller" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Incoming...", -1))
const _hoisted_5 = { class: "flex gap-4 ml-auto" }

import { PhoneLineComposable } from '../../../../ecs/phone/PhoneLine';
import IconComponent from '../../../icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';
import { RadioComposable } from '../../../../ecs/radio/RadioComposable';


export default /*#__PURE__*/_defineComponent({
  __name: 'IncomingPhoneCallWidget',
  props: {
    phoneLine: null
  },
  emits: ['decline', 'answer'],
  setup(__props: any, { emit }) {

const props = __props as {
  phoneLine: PhoneLineComposable | RadioComposable;
}





const handleDecline = () => {
  emit('decline', props.phoneLine);
};

const handleAnswer = () => {
  emit('answer', props.phoneLine);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.phoneLine.description.value.title), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", { onClick: handleDecline }, [
        _createVNode(IconComponent, {
          icon: _unref(Icon).PHONE_HANGUP,
          class: "button"
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("button", { onClick: handleAnswer }, [
        _createVNode(IconComponent, {
          icon: _unref(Icon).PHONE_ANSWER,
          class: "button"
        }, null, 8, ["icon"])
      ])
    ])
  ]))
}
}

})